import axios from "axios";

class AuthApi {

    public API_URL: string = 'https://web-api.site-creative.ru'

    public async login(login: string, pass: string): Promise<any>{
        return new Promise<any>(async (resolve, reject) => {
            try {
                await axios.post(this.API_URL + '/auth/login', {
                    username: login,
                    password: pass
                })
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            } catch (e) {
                console.log(e)
                reject(e)
            }
        })
    }

}

export default new AuthApi()